import { useState, useEffect, useRef } from 'react';
import Page from './Page';
import pData from "../data/portfolio.json";

export default function Folder({idx, currentIdx, setIndex, title, total}) {
    const [pageIdx, setPageIdx] = useState(0);
    const startXRef = useRef(null);
    const [openFolder, setOpenFolder] = useState(false);
    const data = pData.pItems;
    const pages = data.map((item, i) => (
        <Page idx={i} currentIdx={pageIdx} setIndex={setPageIdx} total={data.length} key={item.pTitle}>
            <h2><a href={item.aLink} target='_blank'>{item.pTitle}</a></h2>
            <div className="hr"></div>
            <div className="col2">
                <div>
                    {item.pContent.map((pEl, i) => (
                        <p>{pEl}</p>
                    ))}
                </div>
                <div className="pImg" style={{backgroundImage: `url(/p/${item.pImg})`}}></div>
                <div className="hr"></div>
                <div className="hr"></div>
                    {item.pUsed.length > 0 ? <>
                        <div>
                            <h3>Made using:</h3>
                            <ul>
                                {item.pUsed.map((li, j) => (
                                    <li key={j}>{li}</li>
                                ))}
                            </ul>
                        </div>
                        <div></div>
                    </>
                    : null}
            </div>
        </Page>
    ));

    const handleOpenFolder = () => {
        setOpenFolder(!openFolder);
    }
    useEffect(() => {
        setOpenFolder(false);
    }, [currentIdx]);

    const nextPage = () => {
        setIndex(prev => (prev > 0 ? prev - 1 : total - 1));
    }
    const prevPage = () => {
        setIndex(prev => (prev < total - 1 ? prev + 1 : 0));
    }

    const handlePointerDown = (e) => {
        startXRef.current = e.clientX ?? e.touches?.[0].clientX;
        window.getSelection().removeAllRanges();
    };

    const handlePointerUp = (e) => {
        if (startXRef.current == null) return;

        const endX = e.clientX ?? e.changedTouches?.[0].clientX;
        const deltaX = endX - startXRef.current;

        const threshold = 50; // minimum pixels to count as swipe
        if (deltaX > threshold) {
            nextPage();
        } else if (deltaX < -threshold) {
            prevPage();
        }

        startXRef.current = null; // reset
    };
    
    return(
        <div className={idx === currentIdx ? 'folderOuterWrap top' : 'folderOuterWrap'}>
            <div className={openFolder ? 'open folder' : "folder"}  onPointerDown={openFolder ? null : handlePointerDown} onPointerUp={openFolder ? null : handlePointerUp}>
                <div className="folderTex"></div>
                <div className="folderCover">
                    <div className="topSecret">TOP SECRET</div>
                    <div className="handwrittenNote">Open/Close</div>
                    <div className="curvedArrow"></div>
                    <div className="pageNum">
                        <div className="left" onClick={nextPage}>&larr;</div>
                        <div>{idx + 1}</div>
                        <div className="right" onClick={prevPage}>&rarr;</div>
                    </div>
                </div>
            </div>
            <div className="folderBacking">
                <div className="folderTex"></div>
                {pages}
            </div>
            <div className="folderTitle" onClick={handleOpenFolder}>
                <div className="folderTitleTex"></div>
                <h2>{title}</h2>
            </div>
        </div>
    );
}